import { all, call, put, takeLatest } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import { loginSuccess, loginFail } from './actions';
import api from '~/services/api';
import history from '~/services/history';
import ws from '~/services/webSocket';

export function connectSubscribe(token, id) {
  ws.withJwtToken(token).connect();

  const channel =
    ws.getSubscription(`time:${id}`) || ws.subscribe(`time:${id}`);

  // Escutando entrada de novos leads
  channel.on('message', data => {
    toast.success(
      `O lead: ${data.lead_name} com o email: ${data.lead_email} acabou de se cadastrar no produto: ${data.produto} para ser atendido pelo sdr: ${data.user_name}`
    );
  });
}

export function* login({ payload }) {
  try {
    const { email, password } = payload;
    const response = yield call(api.post, 'session', {
      email,
      password,
    });
    const { token, user } = response.data;

    api.defaults.headers.Authorization = `Bearer ${token.token}`;

    yield put(loginSuccess(token, user));
    yield connectSubscribe(token.token, user.time_id);

    history.push('/dashboard');
  } catch (error) {
    yield put(loginFail());
    toast.error('Falha ao fazer o login, verifique seus dados !');
  }
}

export function deslogar() {
  history.push('/');
  ws.close();
}

export function* setToken({ payload }) {
  if (!payload) return;

  const { token } = payload.auth;
  const { profile } = payload.user;

  if (token) {
    api.defaults.headers.Authorization = `Bearer ${token.token}`;
    yield connectSubscribe(token.token, profile.time_id);
  }
}

export default all([
  takeLatest('persist/REHYDRATE', setToken),
  takeLatest('@auth/LOGIN_REQUEST', login),
  takeLatest('@auth/LOGOUT_APP', deslogar),
]);
